var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHorizontalSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1697 217.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aj{fill:url(#u);}.ak{fill:url(#t);}.al{fill:url(#v);}.am{fill:url(#p);}.an{fill:url(#o);}.ao{fill:url(#s);}.ap{fill:url(#q);}.aq{fill:url(#r);}.ar{fill:url(#i);}.as{fill:url(#h);}.at{fill:url(#k);}.au{fill:url(#j);}.av{fill:url(#m);}.aw{fill:url(#l);}.ax{fill:url(#n);}.ay{fill:url(#x);}.b`{fill:url(#w);}.ba{fill:url(#y);}.bb{fill:url(#aa);}.bc{fill:url(#ag);}.bd{fill:url(#ab);}.be{fill:url(#ah);}.bf{fill:url(#ai);}.bg{fill:url(#ad);}.bh{fill:url(#ae);}.bi{fill:url(#af);}.bj{fill:url(#a`);}.bk{fill:url(#ac);}.bl{fill:#bababa;}.bm{fill:#4e9ed7;}.bn{fill:url(#g);}.bn,.bo,.bp,.bq{isolation:isolate;}.bo{fill:url(#f);}.bp{fill:url(#e);}.bq{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 224.49,
    y1: 68.18,
    x2: 7.15,
    y2: 68.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ec3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5cc0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#57b6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4ea7cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4191bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367db5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 18.44,
    y1: 46.16,
    x2: 142.71,
    y2: 46.16,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 60.7,
    y1: 63.43,
    x2: 121.92,
    y2: 63.43,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 95.32,
    y1: 73.19,
    x2: 121.82,
    y2: 73.19,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 96.07,
    y1: 68.18,
    x2: 229.25,
    y2: 68.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ec3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#50abcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4496c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3c88ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#377fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367db5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0,
    y1: 148.89,
    x2: 217.34,
    y2: 148.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6b1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f5aaa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f298a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ee7ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee79a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 81.78,
    y1: 170.9,
    x2: 206.05,
    y2: 170.9,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 102.57,
    y1: 153.64,
    x2: 163.79,
    y2: 153.64,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 102.67,
    y1: 143.87,
    x2: 129.17,
    y2: 143.87,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 4676.78,
    y1: 5540.16,
    x2: 4809.96,
    y2: 5540.16,
    gradientTransform: "translate(4805.22 5689.02) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6b1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f29ba3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f088a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ee7ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee79a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 266.59,
    y1: 107.17,
    x2: 460.16,
    y2: 107.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ececed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9a9aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 916.14,
    y1: 191.77,
    x2: 804.28,
    y2: 79.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#818282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#b3b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 948.22,
    y1: 107.17,
    x2: 1143,
    y2: 107.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e8e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1464.02,
    y1: 189.45,
    x2: 1353.38,
    y2: 78.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#888989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e5e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 7050.55,
    y1: 213.5,
    x2: 7050.55,
    y2: 45.64,
    gradientTransform: "translate(7394.32) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b0b1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 426.76,
    y1: 194.41,
    x2: 596.35,
    y2: 96.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#dad9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5c5c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 478.53,
    y1: 208.17,
    x2: 478.53,
    y2: 104.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#afaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dfe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfc1c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 442.92,
    y1: 213.74,
    x2: 507.42,
    y2: 149.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c7c7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#bebebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbcbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 542.87,
    y1: 213.97,
    x2: 542.87,
    y2: 64.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#cfcece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d9d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 1146.44,
    y1: 195.41,
    x2: 1316.02,
    y2: 97.5,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 1198.2,
    y1: 209.17,
    x2: 1198.2,
    y2: 106,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 1162.6,
    y1: 214.75,
    x2: 1227.09,
    y2: 150.25,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a`",
    x1: 1262.54,
    y1: 214.97,
    x2: 1262.54,
    y2: 65.98,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 660.56,
    y1: 177.35,
    x2: 665.67,
    y2: 172.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#171919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 599.06,
    y1: 107.17,
    x2: 788.88,
    y2: 107.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9c9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8c8d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#828383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 722.41,
    y1: 213.97,
    x2: 722.41,
    y2: 124.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#bcbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9b9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#878888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1507.17,
    x2: 1697,
    xlinkHref: "#ab"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1630.52,
    x2: 1630.52,
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 855.42,
    y1: 53.98,
    x2: 855.42,
    y2: 216.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#afaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9fa0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#888989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 1404.53,
    y1: 54.12,
    x2: 1404.53,
    y2: 217.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a1a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9fa0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#888989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 1111.31,
    y1: 103.43,
    x2: 1039.28,
    y2: 31.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a1a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 1104.36,
    y1: 200.28,
    x2: 1039.89,
    y2: 135.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cccbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a7a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9999"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.38,23.03C18.78,19.78,90.59-9.7,145.66,3.28c24.05,5.67,44.91,19.43,55.92,47,2.59,6.5,5.16,13.36,7.67,20.45,2.19,6.2,4.34,12.58,6.43,19.06h0c2.05,6.39,4.03,12.86,5.94,19.37,.98,3.34,1.94,6.69,2.87,10.04h0c-3.67,10.22-10.77,17.14-18.92,17.14-3.74,0-7.26-1.46-10.33-4.03-2.19-10.75-4.66-21.91-7.51-32.91-.72-2.78-1.46-5.55-2.23-8.3-.95-3.42-1.95-6.81-2.99-10.15-1.81-5.82-3.75-11.49-5.82-16.92-8.59-22.41-19.58-40.51-33.98-47.39-8.67-4.14-18.57-4.21-29.91,1.3-27.03,13.13-47.93,19.6-63.74,22.03C9.08,46.13,1.73,26.38,10.38,23.03Z",
    style: {
      fill: "#4e9ed7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.49,119.21h0c-3.67,10.22-10.77,17.14-18.92,17.14-3.74,0-7.26-1.46-10.33-4.03-2.19-10.75-4.66-21.91-7.51-32.91-.72-2.78-1.46-5.55-2.23-8.3-.95-3.42-1.95-6.81-2.99-10.15-1.81-5.82-3.75-11.49-5.82-16.92-6.41-16.73-14.16-31.06-23.67-40.11,0,0,0-.01-.01-.02-3.22-3.07-6.65-5.53-10.29-7.26-8.67-4.14-18.57-4.21-29.91,1.3-27.03,13.13-47.93,19.6-63.74,22.03C9.08,46.13,1.73,26.38,10.38,23.03,16.14,20.8,51.74,6.23,91.31,1.49c18.12-2.17,37.06-2.28,54.36,1.8,24.05,5.67,44.91,19.43,55.92,47,2.59,6.5,5.16,13.36,7.67,20.45,2.19,6.2,4.34,12.58,6.43,19.06h0c2.05,6.39,4.03,12.86,5.94,19.37,.98,3.34,1.94,6.69,2.87,10.04Z",
    style: {
      fill: "url(#d)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.45,63.03c2.74-2.11,13.36-10.54,28.61-20.31,14.11-2.17,32.29-7.56,55.28-18.04,2.75-1.26,5.57-2.59,8.46-3.99,4.28-2.08,8.35-3.36,12.23-3.93,6.41-.95,12.29,.05,17.69,2.63-6.95-.47-13.91,1.43-20.8,6.3-1.53,1.08-3.07,2.31-4.6,3.7-17.91,16.26-33.23,27.26-46.07,34.46-43.49,24.39-58.72,5.26-50.8-.82Z",
    style: {
      fill: "url(#e)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,90.45c1.05-2.61,4.49-11.52,10.15-23.48,10.11-5.67,21.75-13.69,34.99-24.78,3.58-3,7.27-6.22,11.09-9.68,.7-.64,1.41-1.24,2.11-1.82,.83-.67,1.66-1.3,2.48-1.88-.65,1.8-1.31,3.56-1.97,5.27-8.23,21.4-16.72,36.13-24.62,46-20.79,26.01-37.46,18.38-34.22,10.37Z",
    style: {
      fill: "url(#f)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.32,86.03c7.9-9.88,16.4-24.61,24.62-46,9.41,65.67-19.54,73.05-21.65,62.22-.41-2.08-1.63-7.88-2.97-16.22Z",
    style: {
      fill: "url(#g)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.49,119.21h0c-3.67,10.22-10.77,17.14-18.92,17.14-3.74,0-7.26-1.46-10.33-4.03-2.19-10.75-4.66-21.91-7.51-32.91-.72-2.78-1.46-5.55-2.23-8.3-.95-3.42-1.95-6.81-2.99-10.15-1.81-5.82-3.75-11.49-5.82-16.92-6.41-16.73-14.16-31.06-23.67-40.11,0,0,0-.01-.01-.02C137.48,7.35,91.31,1.49,91.31,1.49c18.12-2.17,37.06-2.28,54.36,1.8,24.05,5.67,44.91,19.43,55.92,47,2.59,6.5,5.16,13.36,7.67,20.45,2.19,6.2,4.34,12.58,6.43,19.06h0c2.05,6.39,4.03,12.86,5.94,19.37,.98,3.34,1.94,6.69,2.87,10.04Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.11,194.03c-8.4,3.25-80.21,32.73-135.28,19.75-24.05-5.67-44.91-19.43-55.92-47-2.59-6.5-5.16-13.36-7.67-20.45-2.19-6.2-4.34-12.58-6.43-19.06h0c-2.05-6.39-4.03-12.86-5.94-19.37-.98-3.34-1.94-6.69-2.87-10.04H0c3.67-10.22,10.77-17.14,18.92-17.14,3.74,0,7.26,1.46,10.33,4.03,2.19,10.75,4.66,21.91,7.51,32.91,.72,2.78,1.46,5.55,2.23,8.3,.95,3.42,1.95,6.81,2.99,10.15,1.81,5.82,3.75,11.49,5.82,16.92,8.59,22.41,19.58,40.51,33.98,47.39,8.67,4.14,18.57,4.21,29.91-1.3,27.03-13.13,47.93-19.6,63.74-22.03,39.98-6.14,47.34,13.61,38.68,16.96Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.03,154.03c-2.74,2.11-13.36,10.54-28.61,20.31-14.11,2.17-32.29,7.56-55.28,18.04-2.75,1.26-5.57,2.59-8.46,3.99-4.28,2.08-8.35,3.36-12.23,3.93-6.41,.95-12.29-.05-17.69-2.63,6.95,.47,13.91-1.43,20.8-6.3,1.53-1.08,3.07-2.31,4.6-3.7,17.91-16.26,33.23-27.26,46.07-34.46,43.49-24.39,58.72-5.26,50.8,.82Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.38,126.62c-1.05,2.61-4.49,11.52-10.15,23.48-10.11,5.67-21.75,13.69-34.99,24.78-3.58,3-7.27,6.22-11.09,9.68-.7,.64-1.41,1.24-2.11,1.82-.83,.67-1.66,1.3-2.48,1.88,.65-1.8,1.31-3.56,1.97-5.27,8.23-21.4,16.72-36.13,24.62-46,20.79-26.01,37.46-18.38,34.22-10.37Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,131.03c-7.9,9.88-16.4,24.61-24.62,46-9.41-65.67,19.54-73.05,21.65-62.22,.41,2.08,1.63,7.88,2.97,16.22Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.02,97.83H.02c3.67-10.22,10.77-17.14,18.92-17.14,3.74,0,7.26,1.46,10.33,4.03,2.19,10.75,4.66,21.91,7.51,32.91,.72,2.78,1.46,5.55,2.23,8.3,.95,3.42,1.95,6.81,2.99,10.15,1.81,5.82,3.75,11.49,5.82,16.92,6.41,16.73,14.16,31.06,23.67,40.11,0,0,0,.01,.01,.02,15.52,16.59,61.69,22.44,61.69,22.44-18.12,2.17-37.06,2.28-54.36-1.8-24.05-5.67-44.91-19.43-55.92-47-2.59-6.5-5.16-13.36-7.67-20.45-2.19-6.2-4.34-12.58-6.43-19.06h0c-2.05-6.39-4.03-12.86-5.94-19.37-.98-3.34-1.94-6.69-2.87-10.04Z",
    style: {
      fill: "url(#m)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,.37l-7.93,46.73h64.25l-3.24,19.6-24.3,147.27h57.15l27.53-166.87h64.24L460.16,.37h-185.64Z",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.15,51.68c-7.66,0-15.01,.78-22.01,2.3-38.4,8.27-66.05,38.33-73.11,80.31-8.76,51.73,17.52,82.6,68.83,82.6,44.64,0,76.35-21.27,87.61-54.65h-52.56c-.19,.35-.39,.69-.6,1.03,0,0-.01,.02-.02,.03-3.73,6.08-9.95,10.18-17.3,12.02-2.92,.73-6.01,1.1-9.2,1.1-.24,0-.48,0-.71-.02-8.69-.15-14.92-3.28-18.54-8.41-3.19-4.49-4.35-10.52-3.39-17.43,0,0,0-.02,.01-.05,0-.04,0-.09,.02-.14,.01-.09,.03-.21,.05-.37,.01-.09,.02-.19,.04-.28,.01-.02,.01-.04,.01-.07,.54-3.59,2.59-17.09,4.64-27.36,.58-2.9,1.3-5.47,2.04-7.68,.78-3.01,1.98-5.78,3.54-8.28,.11-.19,.17-.29,.17-.29,5.46-8.62,15.02-13.88,25.47-13.88,14.18,0,22.94,9.59,20.86,23.36h-46.99l-7.37,31.7h102.34l2.08-13.35c8.34-50.9-17.52-82.19-65.91-82.19Z",
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.99,100.49c25.45-5,45.05-23.36,49.22-46.72,3.41-20.45-4.22-36.28-22.47-45.23-10.79-5.3-25.3-8.18-43.44-8.18h-92.62l-35.46,213.6h100.54c46.31,0,79.26-25.45,85.11-60.49,3.92-23.55-6.78-40.95-24.85-47.77-.99-.38-2.01-.72-3.06-1.02-.02,0-.04,0-.06-.02-.5-.14-1.01-.29-1.53-.42-.06-.02-.12-.03-.18-.05-.38-.1-.76-.2-1.14-.28-3.32-.77-6.83-1.22-10.48-1.33l.02-.12,.4-1.96Zm-72.81,28.78l.04-.22,1.01-6.45h.08l8.78-51.83,.04-.24,1.34-8.21v-.02l2.69-16.46h24.62c14.18,0,23.78,7.09,21.69,20.44-2.08,12.93-14.18,20.45-29.2,20.45h-22.08l-5.76,35.87h25.76c1.66,0,3.25,.07,4.75,.22,.84,.07,1.66,.17,2.47,.3,6.32,.97,11.1,3.34,14.09,6.96t.01,.01c3.22,3.89,4.4,9.23,3.29,15.88-2.08,14.18-13.35,21.69-32.54,21.69h-27.12l6.04-38.39Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.46,120.52c6.68-41.72-18.36-68.84-65.5-68.84-52.15,0-88.86,33.38-96.79,82.6-8.34,49.23,17.1,82.6,69.25,82.6,47.56,0,80.94-27.11,88.86-69.66h-53.39c-4.17,16.69-14.6,25.86-27.53,25.86-15.01,0-22.53-12.93-18.35-39.21,4.17-26.28,16.27-39.22,31.7-39.22,12.51,0,19.61,9.18,18.35,25.87h53.4Z",
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.74,47.11l-27.06,166.39h57.13l23.05-141.33c-3.14-16.58-14.28-26.53-28.32-26.53-15.07,0-24.81,1.47-24.81,1.47Z",
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588.28,83.68c-6.89-19.03-29.29-32-63.47-32-47.98,0-75.93,25.04-82.6,54.24h52.98c2.92-10.01,11.26-14.55,22.11-14.6,22.91-.1,16.7,25.24,16.12,30.67-.95,8.79-11.88,69.84-12.23,71.16,0,.01-.01,.02-.01,.03l-3.47,20.8h53.82l18.36-109.72c1.24-7.35,.66-14.29-1.61-20.57Zm-66.34,80.09c-1.74,5.74-4.25,18.6-19.76,30.15-4.5,3.37-10.09,6.62-17.09,9.55-22.28,9.34-55.13,7.02-60.29-28.06-2.3,27.83,16.36,41.06,44.94,41.06,12.63,0,23.88-2.6,33.56-8.64,6.24-3.87,11.83-9.18,16.73-16.13,3.62-13.5,3.01-22.68,1.9-27.93Zm-24.56-29.45c-13.6,6.14-25.69,12.65-24.32,25.05,1.39,12.59,9.36,16.72,9.98,17.02-2.42-2.35-3.49-5.72-2.88-9.98,1.14-7.58,7.1-13.43,18.5-16.01,1.14-.26,2.35-.49,3.61-.68,3.98-.72,7.79-1.44,11.35-2.24,3.79-.84,7.15-3.02,9.51-6.09l.04-.06c7.7-10.07,8.94-27.85,9.07-36.33-.57,15.35-18.78,22.08-34.87,29.33Z",
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.07,159.37c1.39,12.59,9.36,16.72,9.98,17.02,.01,0,.01,.01,.02,.01,2.54,2.47,6.58,3.78,11.71,3.78,10.86,0,22.3-5.88,27.16-16.41-2.25,7.41-5.77,26.67-36.85,39.7-22.28,9.34-55.13,7.02-60.29-28.06,.14-1.82,.38-3.72,.72-5.67,5.84-35.04,33.79-48.39,67.17-50.9,26.78-2.05,37.69-4.93,39.56-13.85-1.05,28.32-62.19,27.31-59.19,54.38Z",
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.16,196.69s.06-.07,.1-.11c.6-.7,1.19-1.43,1.77-2.18,.1-.13,.2-.26,.3-.39,.58-.75,1.15-1.52,1.71-2.31,3.62-13.5,3.01-22.68,1.9-27.93-.07,.23-.14,.47-.21,.72v.03c-.27,.89-.55,1.91-.89,3.05-.02,.06-.04,.12-.05,.18-.06,.2-.12,.4-.18,.6-.03,.1-.06,.2-.1,.31-.06,.2-.12,.39-.19,.59-.04,.11-.08,.23-.12,.34-.11,.33-.22,.66-.35,1-.06,.16-.11,.32-.17,.48-.06,.18-.13,.35-.2,.53-.06,.17-.13,.34-.2,.51-.07,.18-.14,.36-.21,.54-.08,.19-.16,.39-.24,.58-.07,.17-.14,.33-.21,.5-.14,.33-.3,.67-.45,1.02-.08,.17-.16,.34-.24,.5-.1,.21-.2,.42-.31,.64-.09,.18-.18,.36-.27,.54-.11,.21-.22,.43-.34,.65-.09,.18-.19,.36-.29,.54-.17,.31-.35,.63-.53,.95-.12,.21-.25,.43-.38,.65-.14,.23-.28,.47-.43,.71-.13,.2-.25,.4-.39,.6-.13,.2-.27,.41-.4,.61-.14,.21-.28,.42-.43,.64-.14,.2-.29,.4-.43,.61-.29,.4-.58,.8-.89,1.2-.14,.18-.27,.35-.41,.53-.2,.25-.4,.5-.61,.75-.13,.16-.26,.32-.4,.48-.22,.26-.45,.52-.68,.79-.12,.13-.24,.26-.36,.4-.89,.99-1.85,1.98-2.9,2.98-.03,.03-.06,.06-.1,.09-.36,.34-.74,.68-1.12,1.02-.04,.04-.08,.08-.13,.11-1.22,1.08-2.53,2.15-3.96,3.22h0c-4.5,3.37-10.09,6.62-17.09,9.55-22.28,9.34-55.13,7.02-60.29-28.06-2.3,27.83,16.36,41.06,44.94,41.06,14.6,0,27.35-3.48,37.98-11.71,.08-.06,.17-.13,.25-.19,.68-.54,1.36-1.09,2.03-1.67,.05-.05,.11-.1,.16-.14,.62-.54,1.23-1.1,1.84-1.68,.09-.08,.18-.17,.26-.25,.63-.61,1.26-1.24,1.87-1.89,.09-.09,.17-.18,.26-.27,.6-.64,1.19-1.3,1.77-1.97Z",
    style: {
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.15,106.36c-.02,.14-.04,.28-.06,.42-.04,.3-.08,.6-.13,.89-.03,.17-.07,.33-.11,.5-.06,.26-.11,.52-.18,.78-.05,.18-.1,.35-.15,.52-.07,.24-.14,.48-.22,.71-.06,.18-.12,.35-.19,.52-.08,.22-.17,.45-.26,.67-.07,.17-.15,.35-.23,.52-.1,.21-.2,.43-.3,.64-.09,.17-.17,.34-.26,.51-.11,.21-.23,.41-.34,.61-.1,.17-.2,.33-.3,.49-.12,.2-.25,.39-.38,.58-.11,.16-.22,.32-.33,.48-.14,.19-.28,.38-.42,.56-.12,.16-.24,.31-.36,.47-.15,.19-.31,.37-.46,.55-.13,.15-.25,.3-.38,.45-.16,.18-.34,.36-.51,.54-.13,.14-.26,.28-.4,.42-.2,.2-.41,.4-.62,.6-.25,.24-.5,.47-.76,.7-.19,.17-.38,.34-.57,.5-.18,.15-.36,.3-.55,.45-.17,.14-.35,.29-.52,.43-.19,.15-.39,.3-.59,.45-.18,.13-.35,.27-.53,.4-.2,.15-.41,.29-.61,.44-.18,.13-.36,.26-.55,.39-.21,.15-.43,.29-.64,.43-.19,.12-.37,.25-.56,.37-.22,.14-.44,.28-.67,.42-.19,.12-.39,.24-.58,.36-.23,.14-.45,.28-.68,.41-.2,.12-.4,.24-.61,.36-.23,.13-.46,.26-.69,.4-.21,.12-.43,.24-.64,.36-.22,.12-.45,.25-.68,.37-.23,.13-.47,.25-.71,.38-.21,.11-.42,.23-.64,.34-.27,.14-.55,.28-.83,.43-.18,.09-.36,.19-.54,.28-.38,.19-.77,.38-1.16,.58-.08,.04-.15,.07-.23,.11-4.41,2.16-9.1,4.15-13.61,6.18h0c-13.61,6.14-25.69,12.65-24.32,25.05,1.39,12.59,9.36,16.72,9.98,17.02-2.42-2.35-3.49-5.72-2.88-9.98,1.16-7.71,7.32-13.63,19.12-16.14,.26-.06,.52-.11,.79-.16,.72-.14,1.45-.27,2.2-.39,3.98-.72,7.79-1.44,11.35-2.24,3.79-.84,7.15-3.02,9.51-6.09l.04-.06c7.7-10.07,8.94-27.85,9.07-36.33-.02,.46-.05,.92-.1,1.36Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.9,104.25l-18.36,109.72h-53.82l3.47-20.8s.01-.02,.01-.03c.35-1.31,11.28-62.37,12.23-71.16,.58-5.43,6.8-30.77-16.12-30.67-10.86,.05-19.19,4.59-22.11,14.6,.81-3.57,8.88-35.03,41.02-39.76,26.31-3.87,44.38,1.81,52.07,17.53,2.28,6.27,2.86,13.22,1.61,20.57Z",
    style: {
      fill: "url(#v)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1307.96,84.69c-6.89-19.03-29.29-32-63.47-32-47.98,0-75.93,25.04-82.6,54.24h52.98c2.92-10.01,11.26-14.55,22.11-14.6,22.91-.1,16.7,25.24,16.12,30.67-.95,8.79-11.88,69.84-12.23,71.16,0,.01-.01,.02-.01,.03l-3.47,20.8h53.82l18.36-109.72c1.24-7.35,.66-14.29-1.61-20.57Zm-66.34,80.09c-1.74,5.74-4.25,18.6-19.76,30.15-4.5,3.37-10.09,6.62-17.09,9.55-22.28,9.34-55.13,7.02-60.29-28.06-2.3,27.83,16.36,41.06,44.94,41.06,12.63,0,23.88-2.6,33.56-8.64,6.24-3.87,11.83-9.18,16.73-16.13,3.62-13.5,3.01-22.68,1.9-27.93Zm-24.56-29.45c-13.6,6.14-25.69,12.65-24.32,25.05,1.39,12.59,9.36,16.72,9.98,17.02-2.42-2.35-3.49-5.72-2.88-9.98,1.14-7.58,7.1-13.43,18.5-16.01,1.14-.26,2.35-.49,3.61-.68,3.98-.72,7.79-1.44,11.35-2.24,3.79-.84,7.15-3.02,9.51-6.09l.04-.06c7.7-10.07,8.94-27.85,9.07-36.33-.57,15.35-18.78,22.08-34.87,29.33Z",
    style: {
      fill: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.74,160.37c1.39,12.59,9.36,16.72,9.98,17.02,.01,0,.01,.01,.02,.01,2.54,2.47,6.58,3.78,11.71,3.78,10.86,0,22.3-5.88,27.16-16.41-2.25,7.41-5.77,26.67-36.85,39.7-22.28,9.34-55.13,7.02-60.29-28.06,.14-1.82,.38-3.72,.72-5.67,5.84-35.04,33.79-48.39,67.17-50.9,26.78-2.05,37.69-4.93,39.56-13.85-1.05,28.32-62.19,27.31-59.19,54.38Z",
    style: {
      fill: "url(#x)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.84,197.69s.06-.07,.1-.11c.6-.7,1.19-1.43,1.77-2.18,.1-.13,.2-.26,.3-.39,.58-.75,1.15-1.52,1.71-2.31,3.62-13.5,3.01-22.68,1.9-27.93-.07,.23-.14,.47-.21,.72v.03c-.27,.89-.55,1.91-.89,3.05-.02,.06-.04,.12-.05,.18-.06,.2-.12,.4-.18,.6-.03,.1-.06,.2-.1,.31-.06,.2-.12,.39-.19,.59-.04,.11-.08,.23-.12,.34-.11,.33-.22,.66-.35,1-.06,.16-.11,.32-.17,.48-.06,.18-.13,.35-.2,.53-.06,.17-.13,.34-.2,.51-.07,.18-.14,.36-.21,.54-.08,.19-.16,.39-.24,.58-.07,.17-.14,.33-.21,.5-.14,.33-.3,.67-.45,1.02-.08,.17-.16,.34-.24,.5-.1,.21-.2,.42-.31,.64-.09,.18-.18,.36-.27,.54-.11,.21-.22,.43-.34,.65-.09,.18-.19,.36-.29,.54-.17,.31-.35,.63-.53,.95-.12,.21-.25,.43-.38,.65-.14,.23-.28,.47-.43,.71-.13,.2-.25,.4-.39,.6-.13,.2-.27,.41-.4,.61-.14,.21-.28,.42-.43,.64-.14,.2-.29,.4-.43,.61-.29,.4-.58,.8-.89,1.2-.14,.18-.27,.35-.41,.53-.2,.25-.4,.5-.61,.75-.13,.16-.26,.32-.4,.48-.22,.26-.45,.52-.68,.79-.12,.13-.24,.26-.36,.4-.89,.99-1.85,1.98-2.9,2.98-.03,.03-.06,.06-.1,.09-.36,.34-.74,.68-1.12,1.02-.04,.04-.08,.08-.13,.11-1.22,1.08-2.53,2.15-3.96,3.22h0c-4.5,3.37-10.09,6.62-17.09,9.55-22.28,9.34-55.13,7.02-60.29-28.06-2.3,27.83,16.36,41.06,44.94,41.06,14.6,0,27.35-3.48,37.98-11.71,.08-.06,.17-.13,.25-.19,.68-.54,1.36-1.09,2.03-1.67,.05-.05,.11-.1,.16-.14,.62-.54,1.23-1.1,1.84-1.68,.09-.08,.18-.17,.26-.25,.63-.61,1.26-1.24,1.87-1.89,.09-.09,.17-.18,.26-.27,.6-.64,1.19-1.3,1.77-1.97Z",
    style: {
      fill: "url(#y)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.83,107.36c-.02,.14-.04,.28-.06,.42-.04,.3-.08,.6-.13,.89-.03,.17-.07,.33-.11,.5-.06,.26-.11,.52-.18,.78-.05,.18-.1,.35-.15,.52-.07,.24-.14,.48-.22,.71-.06,.18-.12,.35-.19,.52-.08,.22-.17,.45-.26,.67-.07,.17-.15,.35-.23,.52-.1,.21-.2,.43-.3,.64-.09,.17-.17,.34-.26,.51-.11,.21-.23,.41-.34,.61-.1,.17-.2,.33-.3,.49-.12,.2-.25,.39-.38,.58-.11,.16-.22,.32-.33,.48-.14,.19-.28,.38-.42,.56-.12,.16-.24,.31-.36,.47-.15,.19-.31,.37-.46,.55-.13,.15-.25,.3-.38,.45-.16,.18-.34,.36-.51,.54-.13,.14-.26,.28-.4,.42-.2,.2-.41,.4-.62,.6-.25,.24-.5,.47-.76,.7-.19,.17-.38,.34-.57,.5-.18,.15-.36,.3-.55,.45-.17,.14-.35,.29-.52,.43-.19,.15-.39,.3-.59,.45-.18,.13-.35,.27-.53,.4-.2,.15-.41,.29-.61,.44-.18,.13-.36,.26-.55,.39-.21,.15-.43,.29-.64,.43-.19,.12-.37,.25-.56,.37-.22,.14-.44,.28-.67,.42-.19,.12-.39,.24-.58,.36-.23,.14-.45,.28-.68,.41-.2,.12-.4,.24-.61,.36-.23,.13-.46,.26-.69,.4-.21,.12-.43,.24-.64,.36-.22,.12-.45,.25-.68,.37-.23,.13-.47,.25-.71,.38-.21,.11-.42,.23-.64,.34-.27,.14-.55,.28-.83,.43-.18,.09-.36,.19-.54,.28-.38,.19-.77,.38-1.16,.58-.08,.04-.15,.07-.23,.11-4.41,2.16-9.1,4.15-13.61,6.18h0c-13.61,6.14-25.69,12.65-24.32,25.05,1.39,12.59,9.36,16.72,9.98,17.02-2.42-2.35-3.49-5.72-2.88-9.98,1.16-7.71,7.32-13.63,19.12-16.14,.26-.06,.52-.11,.79-.16,.72-.14,1.45-.27,2.2-.39,3.98-.72,7.79-1.44,11.35-2.24,3.79-.84,7.15-3.02,9.51-6.09l.04-.06c7.7-10.07,8.94-27.85,9.07-36.33-.02,.46-.05,.92-.1,1.36Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.57,105.25l-18.36,109.72h-53.82l3.47-20.8s.01-.02,.01-.03c.35-1.31,11.28-62.37,12.23-71.16,.58-5.43,6.8-30.77-16.12-30.67-10.86,.05-19.19,4.59-22.11,14.6,.81-3.57,8.88-35.03,41.02-39.76,26.31-3.87,44.38,1.81,52.07,17.53,2.28,6.27,2.86,13.22,1.61,20.57Z",
    style: {
      fill: "url(#a`)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "663.84 170.42 662.4 179.17 662.39 179.18 663.84 170.42",
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M634.52,.37l-35.46,213.6h57.57l5.75-34.79h.01l1.44-8.76,.3-1.81,10.12-61.01h-.01l1.72-10.32,.48-2.89L692.1,.37h-57.57Zm88.34,123.7l66.02-70.29h-64.66l-40.25,47.68c-4.81,5.7-7.58,12.85-7.86,20.31l-1.04,28.18c-.2,5.38,.77,10.75,2.84,15.73l3.06,7.37,16.97,40.94h65.92l-40.95-89.79-.05-.11Z",
    style: {
      fill: "url(#ab)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.85,213.97h-65.92l-16.97-40.94c.17-1.79,.36-3.68,.59-5.64,3.41-29.33,26.77-39.62,41.36-43.21l40.95,89.79Z",
    style: {
      fill: "url(#ac)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1542.64,.37l-35.46,213.6h57.57l5.75-34.79h.01l1.44-8.76,.3-1.81,10.12-61.01h-.01l1.72-10.32,.48-2.89L1600.21,.37h-57.57Zm88.34,123.7l66.02-70.29h-64.66l-40.25,47.68c-4.81,5.7-7.58,12.85-7.86,20.31l-1.04,28.18c-.2,5.38,.77,10.75,2.84,15.73l3.06,7.37,16.97,40.94h65.92l-40.95-89.79-.05-.11Z",
    style: {
      fill: "url(#ad)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.97,213.97h-65.92l-16.97-40.94c.17-1.79,.36-3.68,.59-5.64,3.41-29.33,26.77-39.62,41.36-43.21l40.95,89.79Z",
    style: {
      fill: "url(#ae)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M934.47,162.24c-11.27,33.38-42.97,54.65-87.61,54.65-51.31,0-77.59-30.87-68.83-82.6,7.06-41.98,34.71-72.04,73.11-80.31-49.3,20.2-49.43,75.85-23.24,106.4,2.6,3.03,5.14,5.54,7.64,7.62,3.62,5.13,9.85,8.26,18.54,8.41,3.58,.31,6.9-.16,9.91-1.08,7.35-1.83,13.57-5.93,17.3-12.02,.01,0,.02-.02,.02-.03,.47-.56,.71-.89,.71-.89l1.08-.14h51.37Z",
    style: {
      fill: "url(#af)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.42,147.34c-10.02,47.11-44.64,69.68-89.29,69.68-51.31,0-77.59-30.87-68.83-82.6,7.06-41.98,34.71-72.04,73.11-80.31-72.36,43.11-13.71,109.19-11.22,111.27,3.62,5.13,10.63,9.85,24.06,6.01,14.03-4.01,19.04-24.06,19.04-24.06h53.12Z",
    style: {
      fill: "url(#ag)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21,53.78c-4.17,23.35-23.78,41.72-49.22,46.72l-.42,2.08c5.94,.18,11.49,1.25,16.46,3.13-15.95,5.35-36.33,12.07-52.62,17.42-2.22-.35-4.62-.52-7.22-.52h-25.76l5.76-35.87h22.08c15.02,0,27.11-7.52,29.2-20.45,2.08-13.35-7.51-20.44-21.69-20.44h-24.62s.21-16.78,26.27-31.81c15.16-8.75,37.91-13.25,59.31-5.48,18.25,8.94,25.88,24.78,22.47,45.23Z",
    style: {
      fill: "url(#ah)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.87,153.48c-5.84,35.04-38.8,60.49-85.11,60.49h-35.15c29.48-6.9,64.69-21.16,67.87-46.58,2-16.04-5.84-32.13-10.98-37.3t-.01-.01c-3-3.62-7.77-5.98-14.09-6.96-.8-.13-1.62-.23-2.47-.3,6.09-8.47,18.58-21.03,38.65-20.37,3.28,.1,6.77,.55,10.46,1.45,.38,.08,.76,.18,1.14,.28,.06,.02,.12,.03,.18,.05,.52,.13,1.03,.28,1.53,.42,.02,.01,.04,.01,.06,.02,1.04,.3,2.06,.64,3.06,1.02,18.07,6.83,28.77,24.22,24.85,47.77Z",
    style: {
      fill: "url(#ai)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontalSvg);
export default __webpack_public_path__ + "static/media/logo-horizontal-svg.38b5fc3c624597350f46e147a55267c3.svg";
export { ForwardRef as ReactComponent };